import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-600);
`

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Label = styled.label`
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  display: block;
  margin-bottom: var(--space-200);
`

export const SectionLabel = styled.label`
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  display: block;
  margin-bottom: var(--space-400);
  border-bottom: 1px solid var(--border-primary);
`

export const IconPreview = styled.img`
  max-width: 180px;
  max-height: 180px;
  object-fit: cover;
  object-position: center;
  border-radius: var(--radius-brand);
  display: block;
  border: 1px solid var(--border-primary);
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-200);
  height: 200px;
`

export const IconInfo = styled.div`
  font-size: var(--font-size-200);
  color: var(--text-secondary);
  margin-top: var(--space-200);
`
